module.exports = __webpack_public_path__ + "images/icons_v2/check-green-6e505e6f.svg";